import { Link, useNavigate } from "react-router-dom";
import SocialLinks from "@/components/SocialLinks";

// Lightweight chrome for standalone public pages (draft marketing pages + 404).
// The footer intentionally links only to always-public destinations (never to the
// draft pages), so draft pages stay reachable only via their direct preview links.
export default function MarketingLayout({ children }) {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FCFAF6] text-[#291B2D] animate-fade-in flex flex-col">
      <header className="max-w-[1280px] w-full mx-auto flex items-center justify-between px-6 py-6" data-testid="marketing-header">
        <Link to="/" className="flex items-center gap-3" data-testid="marketing-logo">
          <span className="w-11 h-11 rounded-2xl bg-[#291B2D] text-white flex items-center justify-center font-heading text-xl">S<span className="text-[#C89B55]">+</span></span>
          <span className="font-heading text-2xl tracking-tight">Sisterhood<span className="text-[#C89B55]">+</span></span>
        </Link>
        <div className="flex items-center gap-3">
          <button onClick={() => navigate("/login")} data-testid="marketing-signin"
            className="hidden sm:inline text-sm text-[#291B2D]/70 hover:text-[#291B2D] transition-smooth">Sign In</button>
          <button onClick={() => navigate("/get-started")} data-testid="marketing-cta"
            className="bg-[#291B2D] text-white text-sm rounded-full px-4 py-2 hover:bg-[#352238] transition-smooth">Start free</button>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-[#291B2D]/5 py-10 text-center text-xs text-[#291B2D]/50 space-y-4">
        <div className="flex items-center justify-center gap-5">
          <Link to="/" className="hover:text-[#291B2D] transition-smooth">Home</Link>
          <Link to="/therapists" className="hover:text-[#291B2D] transition-smooth">Find a Therapist</Link>
          <Link to="/terms" className="hover:text-[#291B2D] transition-smooth">Terms</Link>
        </div>
        <SocialLinks />
        <p>Sisterhood+ · Not a substitute for professional care · If you are in crisis, call or text <a href="tel:988" className="text-[#291B2D] underline">988</a></p>
        <p className="text-[#291B2D]/60 font-medium">© 2026 Renewing Minds Counseling and Consulting Services. All rights reserved.</p>
      </footer>
    </div>
  );
}
